module.exports = __webpack_public_path__ + "static/media/10-1.c25b4b69.jpg";